import { useState } from "react";
import ChevronUpSvg from "../../../icons/ChevronUpSvg";
import ChevronDownSvg from "../../../icons/ChevronDownSvg";
import { Button } from "../ui/button";

interface ExpandableTextContentProps {
  title: string;
  textContent: string | React.ReactNode;
  titleClassName?: string;
  textContentClassName?: string;
  shadowClassName?: string;
}

export function ExpandableTextContent({
  title,
  textContent,
  titleClassName = "",
  textContentClassName = "",
  shadowClassName = "",
}: ExpandableTextContentProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="pb-5">
      <div className="flex justify-between items-center gap-4 mb-2 lg:mb-3">
        <h3
          className={`flex-1 mb-2 font-openSans font-semibold text-lg ${titleClassName}`}
        >
          {title}
        </h3>
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          className="group flex flex-shrink-0 justify-center items-center !bg-white p-2 rounded-full transition-all duration-200 cursor-pointer"
          aria-label={isExpanded ? "Collapse disclaimer" : "Expand disclaimer"}
        >
          {isExpanded ? (
            <ChevronUpSvg
              width={20}
              height={20}
              fill="#1A1A1A"
              className="group-hover:scale-110 transition-transform duration-200"
            />
          ) : (
            <ChevronDownSvg
              width={20}
              height={20}
              fill="#1A1A1A"
              className="group-hover:scale-110 transition-transform duration-200"
            />
          )}
        </Button>
      </div>
      <div className="relative">
        <div
          className={`overflow-hidden transition-all duration-500 ease-in-out ${
            !isExpanded ? "max-h-[60px] lg:max-h-[140px]" : "max-h-[1000px]"
          }`}
        >
          <div className="bg-white">
            {typeof textContent === "string" ? (
              <p
                className={`font-openSans font-normal text-brand-primaryTextDarkGrey text-sm leading-4 tracking-wide ${textContentClassName}`}
              >
                {textContent}
              </p>
            ) : (
              textContent
            )}
          </div>
        </div>
        {!isExpanded && (
          <div
            className={`right-0 bottom-0 left-0 absolute bg-gradient-to-t from-brand-lightPink to-transparent h-8 pointer-events-none ${shadowClassName}`}
          />
        )}
      </div>
    </div>
  );
}
